import { fetchJsonResponse } from '@/ai/api'
import tools from '@/api/chatGPT/chatLog/functions'
import { buildWorkflowAssistantPrompt } from '@/ai/prompts'

export const generateWorkflowAssistant = async ({
  workflow,
  messagesHistory = [],
  prompt,
  abortController,
  currentUIState
}) => {
  if (!workflow) {
    return null
  }

  const messages = buildWorkflowAssistantPrompt({
    workflow,
    messagesHistory,
    prompt,
    currentUIState
  })

  try {
    const response = await fetchJsonResponse({
      messages,
      useCase: 'assistant',
      aiVersion: 5,
      tools,
      signal: abortController?.signal
    })

    return response || null
  } catch (error) {
    // If the user cancels, treat it as a normal no-op.
    if (abortController?.signal?.aborted || error?.name === 'AbortError') {
      return null
    }

    return {
      error: {
        name: error?.name || 'Error',
        message: error?.message || 'Failed to generate AI response'
      }
    }
  }
}

export const generateFunctionCallResponse = async ({
  workflow,
  messagesHistory = [],
  prompt,
  originalResponse = [],
  functionResults = [],
  abortController
}) => {
  if (!workflow || !functionResults.length || !originalResponse.length) {
    return null
  }

  const messages = buildWorkflowAssistantPrompt({
    workflow,
    messagesHistory,
    prompt
  })

  for (const item of originalResponse) {
    if (item.type === 'function_call' || item.type === 'message') {
      messages.push(item)
    }
  }

  for (const { callId, result } of functionResults) {
    const payload = result?.success === false
      ? { success: false, error: result.error }
      : { success: true }

    messages.push({
      type: 'function_call_output',
      call_id: callId,
      output: JSON.stringify(payload)
    })
  }

  try {
    const response = await fetchJsonResponse({
      messages,
      useCase: 'assistant',
      aiVersion: 5,
      tools: [],
      signal: abortController?.signal
    })

    return response || null
  } catch (error) {
    console.error('Error generating function call response:', error)
    return null
  }
}
